module.exports = __webpack_public_path__ + "static/media/6-min.94869d4c.jpg";